// The model sometimes writes its evidence table and bullets without blank lines, or
// even on one line with spaces. GFM needs blank lines between blocks, so such an
// answer renders as one long paragraph of pipes. This puts the structure back. The
// same rules live in the backend's utils.normalize_markdown for stored answers; this
// copy also runs on the streaming draft and on messages saved before the fix.

const TABLE_ROW = /^\s*\|/;
const DELIM = /\|\s*:?-{3,}/;
const GLUED_ROWS = /\|\s+\|/;
const LIST_ITEM = /^\s{0,3}([-*+]|\d+[.)])\s+\S/;
const HEADING = /^\s{0,3}#{1,6}\s+\S/;
const BOLD_LINE = /^\s*\*\*[^*\n]+\*\*:?\s*$/;

function splitGlued(line) {
  if ((line.match(/\|/g) || []).length < 4 || !DELIM.test(line) || !GLUED_ROWS.test(line)) return [line];
  const first = line.indexOf('|');
  const out = [];
  const prefix = line.slice(0, first).trim();
  if (prefix) out.push(prefix);
  let rest = line.slice(first).replace(/\|\s+\|/g, '|\n|');
  const rows = rest.split('\n');
  const last = rows[rows.length - 1];
  const m = last.match(/^(\|.*\|)\s*([^|]*[^|\s])\s*$/);
  if (m) {
    rows[rows.length - 1] = m[1];
    let trailing = m[2];
    if (trailing.startsWith('**')) {
      const parts = trailing.split(/\s+-\s+(?=\S)/);
      out.push(...rows, parts[0], ...parts.slice(1).map((p) => `- ${p}`));
      return out;
    }
    out.push(...rows, trailing);
    return out;
  }
  out.push(...rows);
  return out;
}

function kind(line) {
  if (!line.trim()) return 'blank';
  if (TABLE_ROW.test(line)) return 'table';
  if (LIST_ITEM.test(line)) return 'list';
  if (HEADING.test(line) || BOLD_LINE.test(line)) return 'heading';
  return 'text';
}

export function normalizeMarkdown(text) {
  if (!text || typeof text !== 'string') return '';
  const lines = text.replace(/\r\n/g, '\n').split('\n').flatMap(splitGlued);
  const out = [];
  let prev = 'blank';
  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    const k = kind(line);
    if (k !== 'blank' && prev !== 'blank') {
      const startsBlock = (k === 'table' && prev !== 'table') || (k === 'list' && prev !== 'list') || k === 'heading';
      const endsBlock = prev === 'heading' || (prev === 'table' && k !== 'table') || (prev === 'list' && k !== 'list');
      if (startsBlock || endsBlock) out.push('');
    }
    out.push(line);
    prev = k;
  }
  return out.join('\n');
}

export default normalizeMarkdown;
